import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from "./App.vue";
import router from "./router";
import startQiankun from "./micro";
import '@/assets/css_common/index.scss';
import '@/assets/css/index.scss';
// 语言
import i18n from '@/language';
// 全局组件components
import Components from './components';
startQiankun({
    prefetch: false,
    sandbox: { experimentalStyleIsolation: false, strictStyleIsolation: true }
});
const app = createApp(App);
app.use(router).use(ElementPlus).use(Components).use(i18n);
app.mount('#main-app');
